import Link from "next/link";
import ThemeSwitch from "@/components/elements/ThemeSwitch";
import Menu from "@/components/layout/Menu";
import MobileMenu from "@/components/layout/MobileMenu";
import styles from "./Header.module.css";
import ExportedImage from "next-image-export-optimizer";

interface HeaderProps {
	scroll: boolean;
	isMobileMenu: boolean;
	handleMobileMenu: () => void;
	isSearch: boolean;
	handleSearch: () => void;
	isOffCanvas: boolean;
	handleOffCanvas: () => void;
}

export default function Header({
								   scroll,
								   isMobileMenu,
								   handleMobileMenu,
								   isSearch,
								   handleSearch,
								   isOffCanvas,
								   handleOffCanvas,
							   }: HeaderProps) {
	return (
		<header>
			<nav
				className={[
					"navbar navbar-expand-lg navbar-light w-100 border-bottom",
					styles.navRoot,
					scroll ? styles.navSticky : "",
				]
					.filter(Boolean)
					.join(" ")}
			>
				<div className="container-fluid px-md-8 px-2">
					<Link className="navbar-brand d-flex main-logo align-items-center" href="/">
						<ExportedImage
							placeholder="empty"
							src="/assets/imgs/new/main/icon.svg"
							alt="The Sixth Hammer"
							width={32}
							height={32}
						/>
					</Link>

					<Menu />

					<div className="d-flex align-items-center pe-5 pe-lg-0 me-5 me-lg-0">
						<ThemeSwitch />
						<button
							type="button"
							className="burger-icon burger-icon-white border rounded-3 bg-white"
							onClick={handleMobileMenu}
							aria-label="Toggle navigation menu"
						>
							<span className="burger-icon-top" />
							<span className="burger-icon-mid" />
							<span className="burger-icon-bottom" />
						</button>
					</div>
				</div>
			</nav>
			<MobileMenu handleMobileMenu={handleMobileMenu} isMobileMenu={isMobileMenu} />
		</header>
	);
}
